<template>
  <div>
    <!-- 导航 -->
    <el-breadcrumb>
      <el-breadcrumb-item>
        <router-link to="/">首页</router-link>
      </el-breadcrumb-item>
      <el-breadcrumb-item>课程报名</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 搜索 -->
    <div class="content">
      <el-form
        inline
        :model="query"
        label-position="right"
        label-width="60px"
        size="small"
        class="query-form"
        @submit.native.prevent="getList()"
      >
        <el-form-item label="搜索">
          <el-input v-model="query.key" placeholder="请输入关键词"></el-input>
        </el-form-item>
        <el-form-item
          label="课程"
          label-width="80px"
          style="margin-left: -15px"
        >
          <el-select
            v-model="query.japaneseID"
            filterable
            clearable
            @change="getList()"
          >
            <el-option
              v-for="item in catelist"
              :label="item.title"
              :key="item.id"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="selClick()">查询</el-button>
          <!-- <el-button type="success" @click="dialogVisible=true;form={isEnable:true};">新增</el-button> -->
        </el-form-item>
      </el-form>

      <!-- 主体 -->
      <el-card class="box-card table">
        <div class="clearfix" slot="header">
          <span>课程报名记录列表</span>
        </div>
        <el-tabs v-model="query.state" @tab-click="getList()">
          <el-tab-pane
            v-for="item in statelist"
            :label="item.name"
            :name="item.id.toString()"
            :key="item.id"
          ></el-tab-pane>
        </el-tabs>
        <!-- 列表 -->
        <el-table
          v-loading="loading"
          :data="tableData"
          ref="tableData"
          border
          stripe
          style="width: 100%"
          @sort-chamge="sortChange"
          @filter-change="filterTag"
        >
          <el-table-column prop="createTime" label="申请时间"></el-table-column>
          <el-table-column prop="realName" label="申请人"></el-table-column>
          <el-table-column prop="wechat" label="微信"></el-table-column>
          <el-table-column prop="mobile" label="手机号"></el-table-column>
          <el-table-column
            prop="japaneseTitle"
            label="报名课程"
          ></el-table-column>
          <el-table-column prop="summary" label="申请备注"></el-table-column>
          <el-table-column label="状态">
            <template slot-scope="scope">
              <el-tag type="success" v-if="scope.row.state == 2">{{
                scope.row.stateName
              }}</el-tag>
              <el-tag type="primary" v-else>{{ scope.row.stateName }}</el-tag>
            </template>
          </el-table-column>

          <!-- 操作 -->
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button-group>
                <el-tooltip
                  content="标记处理"
                  placement="top"
                  v-if="scope.row.state == 1"
                >
                  <el-button
                    type="primary"
                    size="small"
                    icon="el-icon-edit"
                    @click="editClick(scope.row)"
                  ></el-button>
                </el-tooltip>
                <!-- <el-tooltip content="删除" placement="top">
                  <el-button
                    type="warning"
                    size="small"
                    icon="el-icon-delete"
                    @click="delClick(scope.row)"
                  ></el-button>
                </el-tooltip> -->
              </el-button-group>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="block" style="margin-top: 20px">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage4"
            :page-size="pageSize"
            :page-sizes="[10, 20, 30, 50, 100]"
            layout="total,sizes,prev,pager,next,jumper"
            :total="total"
          ></el-pagination>
        </div>
      </el-card>
    </div>

    <!-- 弹框 -->
    <el-dialog title="记录审核" :visible.sync="dialogVisible">
      <el-form
        :model="form"
        ref="form"
        label-width="100px"
        :status-icon="true"
        @submit.native.prevent="submitForm(form)"
      >
        <el-form-item prop="summary" label="备注说明">
          <el-input
            type="textarea"
            v-model="form.summary"
            plaveholder="请输入备注"
          ></el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" :loading="submiting" native-type="submit"
            >标记处理</el-button
          >
          <el-button @click="dialogVisible = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import url from "@/plugins/urlHelper.js";
export default {
  data() {
    return {
      domain: url.getDomain(),
      query: {
        cateid: "",
      },
      form: {},
      dialogVisible: false,
      loading: false,
      submiting: false,
      tableData: [],
      total: 0,
      pageSize: 10,
      currentPage4: 1,
      content: "",
      editorConfig: {
        zIndex: 3000, //配置控件组件弹出层
        initialFrameHeight: 300, //设置高度
        initialFrameWidth: "100%", //设置宽度
        UEDITOR_HOME_URL: url.getUEConfig(),
        serverUrl: url.getUE(),
      },
      catelist: [],
      statelist: [
        { id: 0, name: "全部" },
        { id: 1, name: "待处理" },
        { id: 2, name: "已处理" },
      ],
    };
  },
  methods: {
    handleSizeChange: function (val) {
      this.pageSize = val;
      this.getList();
    },
    handleCurrentChange: function (val) {
      this.currentPage4 = val;
      this.getList();
    },
    // 排序
    sortChange: function (sortColumn) {
      this.query.sort = sortColumn.sort;
      this.query.order = sortColumn.order;
      this.getList();
    },
    // 筛选
    filterTag: function (filter) {
      var val = filter["isEnable"][0];
      this.form.isEnable = val;
      this.getList();
    },
    // 分类
    getCateList: function () {
      var _this = this;
      var link = url.getJapanese("getall_japanese");
      $.get(link, {}, (data) => {
        _this.catelist = data;
      });
    },

    // 列表
    getList: function () {
      var _this = this;
      _this.loading = true;
      var params = _this.query;
      params.pageSize = _this.pageSize;
      params.pageIndex = _this.currentPage4;
      var link = url.getJapanese("GetList_Apply");
      $.get(link, params, (data) => {
        _this.loading = false;
        _this.tableData = data.list;
        _this.total = data.total;
      });
    },
    // 查询
    selClick: function () {
      this.currentPage4 = 1;
      this.getList();
    },
    // 编辑
    editClick: function (row) {
      var _this = this;
      _this.form = row;
      _this.dialogVisible = true;
    },
    // 删除
    delClick: function (row) {
      var _this = this;
      var id = row.id;
      var link = url.getVideo("delete_video");

      this.$confirm("确定要删除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          $.post(link, { id: id }, (res) => {
            if (res.status) {
              _this.dialogVisible = false;
              _this.getList();
              _this.$message({
                type: "success",
                message: res.msg,
              });
            } else {
              _this.$message({
                type: "error",
                message: res.msg,
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 提交
    submitForm: function () {
      var _this = this;
      var link = url.getJapanese("Handle_Apply");
      var info = _this.form;

      this.$refs.form.validate((valid) => {
        if (valid) {
          _this.submiting = true;

          // 提交后台  添加或修改
          $.post(link, info, (res) => {
            _this.submiting = false;
            if (res.status) {
              _this.dialogVisible = false;
              _this.getList();
              this.$message({
                type: "success",
                message: res.msg,
              });
            } else {
              _this.$message({
                type: "error",
                message: res.msg,
              });
            }
          });
        } else {
          return false;
        }
      });
    },
  },

  mounted() {
    // 分类
    this.getCateList();
    // 列表
    this.getList();
  },
};
</script>